import {Component, OnInit, ChangeDetectionStrategy} from "@angular/core";
import { HttpClient } from "@angular/common/http";
import {Observable} from "rxjs";


@Component({
    selector: 'list-organizations',
    templateUrl: './list-organizations.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ListOrganizationsComponent implements OnInit {

    organizations: Observable<{id: string, name: string, orgUnitType: string}[]>

    constructor(private http: HttpClient){}

    ngOnInit() {
        this.organizations = this.http.get<{id: string, name: string, orgUnitType: string}[]>('/admin/organizations').pipe()
    }
}